import React from 'react'

import { theme } from '@acorns/grove'
import { useRemoteStrings } from '@acorns/web-utils'
import styled from 'styled-components'

import { ChatInterface } from './ChatInterface'
import { useAIAssistant } from './hooks/useAIAssistant'

// z-index: 98 - stay below Drawer z-index | 502 - get above mobile bottom nav z-index
const AIAssistantContainer = styled.div<{ isVisible: boolean }>`
  background-color: ${theme.colors.primaryWhite};
  border-radius: 20px;
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 98;
  ${(props) => (props.isVisible ? 'display: block;' : 'display: none;')}

  @media screen and (max-width: ${theme.dimensions.breakpointsSmall}px) {
    z-index: 502;
    bottom: 0px;
    left: 0;
  }
`

const OuterContainer = styled.div`
  max-width: 1200px;
`

export const AIAssistantComponent = () => {
  const { showAIAssistant, setShowAIAssistant } = useAIAssistant()
  const { isLoadingRemoteStrings } = useRemoteStrings()
  return isLoadingRemoteStrings ? null : (
    <OuterContainer>
      <AIAssistantContainer isVisible={showAIAssistant}>
        <ChatInterface
          showAIAssistant={showAIAssistant}
          setShowAIAssistant={setShowAIAssistant}
        />
      </AIAssistantContainer>
    </OuterContainer>
  )
}
